import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CommonState, error, isFetching } from '@pec/aion-ui-core/slices/common';
import { enqueueRequestErrorSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';
import { IExecution } from '@pec/aion-ui-core/interfaces/execution';

const name = 'contractorExecutions';

export type FetchContractorExecutionsParams = {
  contractorId: string;
  clientOrganizationId: string;
  automationId: string;
};

export const fetchContractorExecutions = createAsyncThunk(
  `${name}/fetch`,
  async ({ contractorId, clientOrganizationId, automationId }: FetchContractorExecutionsParams, { dispatch }) => {
    try {
      // URLSearchParams encodes `$` as %24 and spaces as `+`, matching the gateway's OData expectations.
      const params = new URLSearchParams({ $filter: `AutomationId eq ${automationId}` });
      const url = `/api/processautomation/v1.0/contractors/${contractorId}/clients/${clientOrganizationId}/executions?${params.toString()}`;
      const response = await axios.get<{ value: IExecution[] }>(url);
      return response.data?.value ?? [];
    } catch (err) {
      dispatch(enqueueRequestErrorSnackbar());
      throw err;
    }
  }
);

export type State = CommonState & {
  executions: IExecution[];
};

const initialState: State = {
  executions: [],
  isFetching: false,
  error: null
};

const contractorExecutions = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchContractorExecutions.pending, isFetching)
      .addCase(fetchContractorExecutions.fulfilled, (state, action) => {
        state.executions = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchContractorExecutions.rejected, error);
  }
});

export const { reducer: contractorExecutionsReducer } = contractorExecutions;
